<template>
  <div class="container">
    <QueryFrame @handlePage="handlePage" @handlePageSize="handlePageSize" :count="count"
      :current="page">
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem" v-if="roleType!==2">
            <label>门店名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <label>任务编号:</label>
            <lk-input :maxlength="10" placeholder="请输入" class="item" clearable
              v-model.trim="query.taskId"></lk-input>
          </div>
          <div class="queryItem">
            <label>患者姓名:</label>
            <lk-input :maxlength="100" placeholder="请输入" class="item" clearable
              v-model.trim="query.patientName"></lk-input>
          </div>
          <div class="queryItem">
            <label>随访电话:</label>
             <lk-input :maxlength="100" placeholder="请输入" class="item" clearable
              v-model.trim="query.phone"></lk-input>
          </div>
          <div class="queryItem">
            <label>随访预约时间:</label>
            <timeStampDatePicker type='daterange' class="item" clearable
              v-model.trim="query.times"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>随访状态:</label>
            <lk-select class="item" v-model.trim="query.interStatus" clearable>
            <lk-option v-for="(item, index) in interviewStatusList" :value="item.code" :key="index">{{item.text}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>创建人:</label>
            <lk-select class="item" v-model.trim="query.createUserName" clearable>
              <lk-option v-for="(item, index) in creatUserList" :value="item" :key="index">{{item}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>随访药师:</label>
            <lk-select class="item" v-model.trim="query.modifiedUserName" clearable>
              <lk-option v-for="(item, index) in modifiedUserList" :value="item" :key="index">{{item}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label >随访药品:</label>
            <lk-input placeholder='请输入药品通用名' class="item" clearable v-model.trim="query.interviewDrugs"></lk-input>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="toSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="btnContainer">
            <DownloadButton @on-click="download" v-if="handlePermission('interviewDowload')"></DownloadButton>
            <lk-button @click="downloadFollowList" type='primary' v-if="handlePermission('pharmacyExport')">导出随访统计表</lk-button>
        </div>
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
    <lk-modal
    v-model="showQuery"
    :closable='true'
    :mask-closable='false'
    width="430"
    title="导出随访统计表"
    >
    <div style="margin-right: 25px" class="downloadContainer">
      <lk-form :model='downloadQuery' ref="download" :rules="downloadRules" :label-width="80">
      <lk-form-item label='查询时间:' prop='queryDate' class="queryItem">
        <timeStampDatePicker  type="month" v-model="downloadQuery.queryDate" :options="beginDateOptions"></timeStampDatePicker>
      </lk-form-item>
      <lk-form-item label='门店:' prop="storeIdList" class="queryItem" v-if="roleType!==2">
        <storeListSelect class="item" v-model="downloadQuery.storeIdList"></storeListSelect>
      </lk-form-item>
      <lk-form-item label='商品:' prop="nameMix" class="queryItem">
        <lk-input :maxlength='20' placeholder='支特商品编码、通用名、商品名、助记码' v-model="downloadQuery.nameMix"></lk-input>
      </lk-form-item>
    </lk-form>
    </div>
    <div slot="footer">
      <lk-button type='primary' @click="onConfirm">确定</lk-button>
      <lk-button class="cancel" @click="closeModal" >取消</lk-button>
    </div>
  </lk-modal>
  </div>
</template>
<script>
import QueryFrame from '@/components/frame/QueryFrame.vue';
import sale from '../../services/sale';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState';
import queryMixins from '../../mixins/queryMixins';
import base from '../../services/base';
import DownloadButton from '../../components/download/DownloadButton';


export default {
  name: 'PatientFollowUpList',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame, DownloadButton,
  },
  data() {
    return {
      beginDateOptions: {
        disabledDate: (date) => {
          return date.valueOf() > utils.getCurrentMonthTimestamp();// .valueOf();
        },
      },
      downloadQuery: {
        queryDate: utils.getCurrentMonthTimestamp(),
        storeIdList: null,
        nameMix: null,
      },
      downloadRules: {
        queryDate: [
          {
            required: true, message: '请选择时间', trigger: 'blur', type: 'number',
          },
        ],
      },
      showQuery: false,
      creatUserList: [], // 创建人
      modifiedUserList: [], // 随访药师
      patientList: [],
      modal: false,
      modalType: 0,
      titleList: [
        '添加',
        '编辑',
        '查看',
      ],
      interviewStatusList: [
        { code: 1, text: '待随访' },
        { code: 2, text: '随访中' },
        { code: 3, text: '本次失访' },
        { code: 4, text: '随访完成' },
      ],
      query: { },
      queryInfo: {
        goodsStoreIds: [],
        inquiryTime: new Date().getTime(),
      },
      columns: [
        { title: '任务编号', key: 'id', minWidth: 116 },
        { title: '门店名称', key: 'storeName', minWidth: 116 },
        { title: '患者姓名', key: 'patientName', minWidth: 116 },
        {
          title: '性别',
          key: 'sex',
          minWidth: 116,
          render: (h, params) => {
            const sex = parseInt(params.row.sex);
            const sexList = ['', '男', '女', '未知'];
            return h('span', sexList[sex]);
          },
        },
        {
          title: '随访电话',
          key: 'phone',
          minWidth: 116,

        },
        {
          title: '随访周期',
          key: 'interviewCycle',
          minWidth: 116,
        },
        { title: '随访预约时间', key: 'times', minWidth: 116 },
        { title: '随访药品', key: 'interviewDrugs', minWidth: 116 },
        {
          title: '随访状态',
          key: 'interviewStatus',
          minWidth: 116,
          render: (h, params) => h('span',
            params.row.interviewStatus
              ? this.interviewStatusList.filter(item => item.code == params.row.interviewStatus)[0].text
              : ''),
        },
        { title: '创建人', key: 'createUserName', minWidth: 116 },
        { title: '随访药师', key: 'modifiedUserName', minWidth: 116 },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          align: 'center',
          width: 130,
          render: (h, params) => h('div', {
            class: {
              textCenter: true,
            },
          }, [
            this.handlePermission('patientFollowUpEdit') && params.row.pharmaceuticalCareOnlyCheck === 2 && h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'patientFollowUpEdit', params: { patientId: params.row.patientId, taskId: params.row.id } });
                },
              },
            }, '编辑'),
            this.handlePermission('patientFollowUpCheck') && params.row.pharmaceuticalCareOnlyCheck === 1 && h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'patientFollowUpCheck', params: { patientId: params.row.patientId, taskId: params.row.id } });
                },
              },
            }, '查看'),
          ]),
        },
      ],
      tableData: [{}],
    };
  },
  methods: {
    onConfirm(e) {
      this.$refs.download.validate((success) => {
        if (success) {
          const target = e.target;
          const downloadCart = this.$root.$children[0].$children[0].$refs.downloadCart; // 导出购物车的位置
          downloadCart.drop(target);
          this.showQuery = false;
          const params = this.downloadQuery;
          params.queryCondition = utils.getQueryCondition('.downloadContainer');
          base.patient.downloadFollowList(params).then((res) => {
            if (res.data.status !== 200) {
              this.$Message.error(res.data.error);
            }
          }).catch((err) => {
            utils.handleError(err);
          });
        }
      });
    },
    closeModal() {
      this.showQuery = false;
    },
    getCreatUser() {
      sale.getCreatUser().then((res) => {
        if (res.data.status === 200) {
          this.creatUserList = res.data.data || [];
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getTaskModifiedUserList() {
      sale.getTaskModifiedUserList().then((res) => {
        if (res.data.status === 200) {
          this.modifiedUserList = res.data.data || [];
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    toSearch() {
      if (this.query.taskId) {
        if (this.query.taskId.indexOf(' ') !== -1) {
          this.$Message.error('任务编号不能包含空格');
          return;
        }
        const regx = /[^0-9]/;
        if (regx.test(this.query.taskId)) {
          this.$Message.error('任务编号必须是数字');
          return;
        }
      }
      this.handleSearch();
    },
    formatParams(params) {
      const temp = utils.deepClone(params);
      temp.page = this.page;
      temp.size = this.size;
      return temp;
    },
    getData() {
      const params = this.formatParams(this.query);
      sale.pharmaceuticalList(params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          this.tableData = res.data.data.list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    clear() {
      this.query = { };
    },
    download() {
      const params = this.formatParams(this.query);
      params.page = 0;
      params.size = 0;
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      base.patient.downloadPatientFollowUpList(params).then((res) => {
        if (res.status !== 200) {
          this.$Message.error(res.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    downloadFollowList() {
      this.downloadQuery = {
        queryDate: utils.getCurrentMonthTimestamp(),
        storeIdList: null,
        nameMix: null,
      };
      this.showQuery = true;
    },
  },
  mounted() {
    Object.assign(this.query, {
      patientName: this.$route.query.patientName || '',
      phone: this.$route.query.phone || '',
      taskId: this.$route.query.taskId || '',
    });
    this.handleSearch(true);
    this.getCreatUser();
    this.getTaskModifiedUserList();
  },
};
</script>
<style lang="less" scoped>
.btnContainer{
  margin-bottom: 12px;
  margin-top:2px;
  >*:first-child{
    margin-right: 8px
  }

}
  .queryContainer{
    display: flex;
    padding-bottom: 16px;
    flex-wrap: wrap;
    .queryItem{
      display: flex;
      align-items: center;
      margin-right: 32px;
      flex-wrap: wrap;
      margin-bottom: 15px;
      .item{
        display: inline-block;
        width: 256px
      }
    }
  }
</style>
